import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__image_asset_category } from '../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { FIELD__image_segments } from '../../../_fields/image/FIELD__image_segments';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../../_base/INVOCATION__base';

export class INVOCATION_VISION_ML__segment_segformer extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_ML__SEGMENT_SEGFORMER;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  /*
   * OUTPUTS
   */

  @FIELD__image_segments.init_as_output()
  out!: FIELD__image_segments;

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.SEGMENTATION })
  out_image!: FIELD__image_asset;

  /*
   *
   */
  get family() {
    return ENUM__ml_asset_family.VISION_SEGFORMER;
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_ML__SEGMENT_SEGFORMER);
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    this.out.hash_sha256_content_source = this.image.hash_sha256_content;
  }
}
